class Accordion {
  constructor() {
    // Constructor logic goes here
    this.timeout = null
    this.headerheight = 0
    this.accordionHeaderheight = 0
    this.accordionHeaders
    this.content
    const self = this

    jQuery(document).ready(() => {
      const accordion = jQuery(".wp-block-getwid-accordion")

      if (!accordion.length) return

      const pageContent = jQuery(".page-content__right-column")
      this.getHeaderHeight()
      this.content = jQuery(".page-content__left-column")

      this.accordionHeaders = jQuery(".wp-block-getwid-accordion__header-wrapper")
      this.accordionHeaders.each(function (index, element) {
        //

        // click event
        jQuery(this).click(function () {
          if (jQuery(this).hasClass("ui-state-active")) {
            const clickedIndex = jQuery(this).index() / 2
            // console.log("Clicked index: ", clickedIndex)

            clearTimeout(this.timeout)
            this.timeout = setTimeout(() => {
              if (window.innerWidth < 768) {
                // const contentHeight = self.content.outerHeight()
                // const offset = clickedIndex * self.accordionHeaderheight + contentHeight + self.headerheight + 10

                const offset = clickedIndex * self.accordionHeaderheight + self.accordionHeaders.first().offset().top - self.headerheight - 10
                // console.log("offset", offset)

                jQuery("html, body").animate(
                  {
                    scrollTop: offset
                  },
                  400
                )
              } else {
                // const offset = Math.max(clickedIndex * self.accordionHeaderheight + self.headerheight + 40, 0)
                const offset = Math.max(clickedIndex * self.accordionHeaderheight + self.accordionHeaders.first()[0].offsetTop - self.headerheight - 10, 0)
                // console.log("scroll to offset", offset)
                pageContent.animate(
                  {
                    scrollTop: offset
                  },
                  400
                )
              }
            }, 100)
          }
        })
      })
    })

    this.events()
  }

  events() {
    // Event listeners go here

    window.addEventListener("resize", () => {
      this.getHeaderHeight()
    })

    // document.addEventListener("DOMContentLoaded", () => {
    //   // console.log("DOM is ready")
    // })
  }

  // Class methods go here
  getHeaderHeight() {
    // get propert header height from root dom element
    this.headerheight = parseInt(getComputedStyle(document.documentElement).getPropertyValue("--site-header-height"), 10)
    // console.log("headerheight", this.headerheight)

    this.accordionHeaderheight = jQuery(".wp-block-getwid-accordion__header-wrapper").outerHeight()
    // console.log("accordionHeaderheight", this.accordionHeaderheight)
  }
}

export default Accordion
